module.exports = __webpack_public_path__ + "static_portal/img/3.f1c001e4.jpg";